export enum ProductType {
  PAYG = 1,
  Cavex = 2,
  ABC = 3,
  Skoot = 4,
  Financing = 5,
}
